$(document).on('click', 'td.toggle-role-ujs', function (e) {
  let self = $(e.target);
  let userId = self.data('user-id');
  let roleId = self.data('role-id');
  self.load('/toggle-role?u=' + userId + '&r=' + roleId);
});
